import { Controller } from "stimulus";
import AjaxLoader from "../../entrypoints/src/admin/utilities/ajax-loader";
import { isEmpty } from "lodash";

export default class extends Controller {
  connect() {
    this.element[this.identifier] = this;
		this.modalId = 'components__pick-schedule-modal';
    this.renderModal();
    this.element.addEventListener('click', this.openModal.bind(this));
  }

  disconnect() {
    this.modalTarget.remove();
  }

  openModal() {
    this.loadTurbo();
  }

  renderModal() {
    let modal = `
      <div class="modal fade show" id="${this.modalId}" data-backdrop="false" style="height: auto">
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header header-border align-items-center justify-content-between bg-zinc-100 py-2">
              <h3 class="modal-title font-lg d-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v2.25A2.25 2.25 0 006 10.5zm0 9.75h2.25A2.25 2.25 0 0010.5 18v-2.25a2.25 2.25 0 00-2.25-2.25H6a2.25 2.25 0 00-2.25 2.25V18A2.25 2.25 0 006 20.25zm9.75-9.75H18a2.25 2.25 0 002.25-2.25V6A2.25 2.25 0 0018 3.75h-2.25A2.25 2.25 0 0013.5 6v2.25a2.25 2.25 0 002.25 2.25z" />
                </svg>
                Selecione um Horário
              </h3>

              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div class="modal-body overflow-hidden fly-out-row p-0">
              <div class="schedule-board-container">
                <turbo-frame id="components__pick-schedule-frame" class="schedule-calendar">
                  <div class="py-3 px-4">Carregando <span class="loading"></span></div>
                </turbo-frame>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-gray-primary" data-dismiss="modal">Cancelar</button>
              <button type="button" class="btn btn-secondary" id="components__pick-schedule-save">Selecionar Horário</button>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modal);
    this.modalTarget = document.querySelector(`#${this.modalId}`);

    if (!this.modalTarget)
      return false;

    this.turboFrameTarget = this.modalTarget.querySelector('turbo-frame#components__pick-schedule-frame');
    this.modalTarget.querySelector('button#components__pick-schedule-save').addEventListener('click', this.onSelectSchedules.bind(this));
  }

  async loadTurbo() {
    $(this.modalTarget).modal('show');
    this.turboFrameTarget.setAttribute('src', this.element.dataset.src);
    await this.turboFrameTarget.loaded;
  }

  onSelectSchedules() {
    const [attributes, object] = this.calendarPickSchedule.querySelectedSchedules();
    let [year, month, day] = object['date'].split('-');

    document.querySelector(this.element.dataset.attributesTarget).innerHTML = attributes.map((node) => node.outerHTML).join('');
    this.element.innerHTML = `
      <span class="mr-1">${new Date(+year, +month - 1, +day).toString().split(' ')[0]}</span>
      ${object['start_time']} às ${object['end_time']}
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
      </svg>
    `;

    this.element.dispatchEvent(new CustomEvent('pick-schedule:save'));
    $(this.modalTarget).modal('hide');
  }

  get valid() {
    return !isEmpty(this.selectedSchedules);
  }

  get selectedSchedules() {
    return this.calendarPickSchedule.getSelectedSchedules();
  }

  get calendarPickSchedule() {
    return this.modalTarget.querySelector('[data-controller="calendar-pick-schedule"]')['calendar-pick-schedule'];
  }
}